import { useEffect, useState, useCallback } from 'react';

function useWindowSize() {
    const isClient = typeof window === 'object';
    const { innerHeight, innerWidth } = window;
  
    const getSize = useCallback(() => {
        return {
            width: isClient ? innerWidth : undefined,
            height: isClient ? innerHeight : undefined
        };
    }, [innerWidth, innerHeight, isClient]);
  
    const [windowSize, setWindowSize] = useState(getSize);
  
    useEffect(() => {
        if (!isClient) {
            return;
        }
      
        function handleResize() {
            setWindowSize(getSize());
        }
  
        window.addEventListener('resize', handleResize);
        // eslint-disable-next-line
        return () => { 
            window.removeEventListener('resize', handleResize);
        };
    }, [getSize, isClient]);
  
    return windowSize;
}

export default useWindowSize;